(() => {
  function init(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const targets = links.map(link => document.getElementById(link.hash.slice(1))).filter(Boolean);
    function mark(id) {
      links.forEach(link => {
        if (link.hash === '#' + id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    links.forEach(link => link.addEventListener('click', () => mark(link.hash.slice(1))));
    function refresh() {
      const marker = nav.getBoundingClientRect().bottom + 40;
      const passed = targets.map(target => ({target, top: target.getBoundingClientRect().top}))
        .filter(item => item.top <= marker).sort((a,b) => b.top - a.top);
      if (passed[0]) mark(passed[0].target.id);
    }
    let queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; refresh(); });
    }
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule);
    refresh();
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(refresh, {rootMargin: '-160px 0px -45% 0px', threshold: 0});
    targets.forEach(target => observer.observe(target));
  }
  document.querySelectorAll('[data-sci-nav]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sci-nav]').forEach(init));
})();
